import { useMemo } from 'react';

import { DrawingTabEnum } from '~/core/enums/drawing-tab.enum';
import { useAppSelector } from '~/redux/hooks';
import { selectNeedRedrawCanvas } from '~/redux/slices/drawingShape';
import { selectSelectedDrawingTab } from '~/redux/slices/shape';
import FreeDrawMessage from '~atoms/FreeDrawMessage';
import { useDrawingShapeContext } from '~contexts';
import PredefinedShapeState from '~organisms/PredefinedShapeState';
import SelectedShape from '~organisms/SelectedShape';
import SidePanelShapeHeader from '~organisms/SidePanelShapeHeader';

const SidePanelShapeTab = () => {
  const {
    getters: { activeDrawingShape, actualDrawingShapes },
  } = useDrawingShapeContext();
  const needRedrawCanvas = useAppSelector(selectNeedRedrawCanvas);

  const selectedDrawingTab = useAppSelector(selectSelectedDrawingTab);
  const contentTab: { [K in DrawingTabEnum]: () => JSX.Element } = {
    [DrawingTabEnum.MODIFY_PREDEFINED_SHAPE_TAB]: PredefinedShapeState,
    [DrawingTabEnum.SELECTED_SHAPE_TAB]: activeDrawingShape?.id
      ? SelectedShape
      : PredefinedShapeState,
    [DrawingTabEnum.FREE_DRAWING_TAB]: FreeDrawMessage,
  };
  const SidePanelShapeContent =
    contentTab[
      selectedDrawingTab ?? DrawingTabEnum.MODIFY_PREDEFINED_SHAPE_TAB
    ];

  /**
   * trigger a redraw of the tab on any drawingShapes update, but only if we're showing the selected shape tab
   *
   * TODO EE3-673 fix this at the lower component level - the InputBoxCustom in SideItemOption.component.tsx should be updating, but it's one state behind
   *  There is probably a missing dependency somewhere, and this is just forcing a dependency at this level.  Using the timestamp is the easiest
   *  way to guarantee it's updating.
   *  Added `needRedrawCanvas` as an additional trigger since that's explicitly updated with the drawing.
   */
  const forceRenderOnDrawingShapesUpdate = useMemo(
    () =>
      needRedrawCanvas &&
      selectedDrawingTab === DrawingTabEnum.SELECTED_SHAPE_TAB
        ? Date.now() + actualDrawingShapes.length
        : undefined,
    // DO NOT change this dependency to actualDrawingShapes.length, or it won't work anymore - ignore the IDE suggestion
    [actualDrawingShapes, selectedDrawingTab, needRedrawCanvas]
  );

  return (
    <>
      <SidePanelShapeHeader />
      <SidePanelShapeContent key={forceRenderOnDrawingShapesUpdate} />
    </>
  );
};

export default SidePanelShapeTab;
